import React from 'react';
import { LogoUploader } from 'swag-client-common/components/logo-uploader';
import { ColorPicker } from 'swag-client-common/components/color-picker';
import BoxDetailsBlock from '../box-details-block';
import BottomButtons from '../bottom-buttons';
import classes from './custom-box-selection.scss';
const CHANGE = 'Change';
const UPLOAD_YOUR_LOGO = 'Upload your logo';
const SAVE = 'Save';
const CONTINUE = 'Continue';
export function CustomBoxSelectionComponent(props) {
  const {
    onBackButton,
    selectedBoxData: {
      pricePerBox,
      assemblyFee,
      productionTimeDays,
      img,
      name,
      description,
      additionalProductionTimeText,
      type
    },
    uploadedLogo,
    isLoading,
    isBoxTypeEdit,
    selectedColor,
    onNext,
    showSuperSpeedConfPopup,
    uploadCustomBoxLogo,
    onChangeColor
  } = props;
  const [color, changeColor] = React.useState(selectedColor);
  const handleLogoChange = event => {
    var _event$target, _event$target$files;
    const file = event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : (_event$target$files = _event$target.files) === null || _event$target$files === void 0 ? void 0 : _event$target$files[0];
    if (!file) {
      return;
    }
    const fileReader = new FileReader();
    fileReader.onload = () => {
      uploadCustomBoxLogo(file);
    };
    fileReader.readAsDataURL(file);
    event.preventDefault();
  };
  const handleColorChange = ({
    cmyk: color
  }) => {
    changeColor(color);
    onChangeColor(color);
  };
  const handleRemoveColor = () => {
    changeColor(null);
    onChangeColor(null);
  };
  const handleNextButton = () => {
    onNext({
      color,
      isEditMode: isBoxTypeEdit,
      showSuperSpeedConfPopup
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement("h1", {
    className: classes.title
  }, "Upload your logo and box color!"), /*#__PURE__*/React.createElement("div", {
    className: classes.subTitle
  }, "After you place your order, we will create a virtual mockup for you to approve before we go into production. Don\u2019t worry, you can edit this later!"), /*#__PURE__*/React.createElement(BoxDetailsBlock, {
    pricePerBox: pricePerBox,
    assemblyFee: assemblyFee,
    productionTimeDays: productionTimeDays,
    previewImage: img,
    name: name,
    description: description,
    additionalProductionTimeText: additionalProductionTimeText,
    selectedBoxDataType: type
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.customizeBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.logoUploader
  }, /*#__PURE__*/React.createElement(LogoUploader, {
    isLoading: isLoading,
    logoBlockClassName: classes.logoBlock,
    handleLogoChange: handleLogoChange,
    buttonText: uploadedLogo ? CHANGE : UPLOAD_YOUR_LOGO,
    currentLogo: uploadedLogo
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ColorPicker, {
    colorBlockClassName: classes.colorBlock,
    colorPickerClassName: classes.colorPicker,
    currentColor: color !== null && color !== void 0 ? color : '',
    handleColorChange: handleColorChange,
    handleRemoveColor: handleRemoveColor
  }))), /*#__PURE__*/React.createElement(BottomButtons, {
    nextText: isBoxTypeEdit ? SAVE : CONTINUE,
    onBackButton: onBackButton,
    isDisabledNextButton: !uploadedLogo || !color || isLoading,
    isDisabledBackButton: isLoading,
    onNextButton: handleNextButton
  }));
}